import { atom } from "jotai";

export const atomAccountAddress = atom<null | string>(localStorage.getItem("@Eriol/system/userId"));

export const atomMediaPermissionsGranted = atom<boolean>(true);

export const atomMediaPermissionsModalOpen = atom<boolean>(true);
